<template>
  <div>
    <!-- <div class="order_grabbing">
      <img class="ordergrabbing_banner" src="/static/qiangdan.png" />
    </div> -->
    <div class="ordergrabbing_list">
      <div class="ordergrabbing_list1">
        <div class="ordergrabbing_box" v-for="(item,index) in sentList">
          <div class="ordergrabbing_top">
            <div class="ordergrabbing_mesgbox">
              <img class="ordergrabbing_img" src="/static/storeClass.png" />
              <div class="ordergrabbing_textvalue">{{item.product_name}}</div>
            </div>
            <div class="ordergrabbing_mesgbox">
              <img class="ordergrabbing_img" src="/static/phoneicon.png" />
              <div class="ordergrabbing_textvalue">手机号码：{{item.mobile}}</div>
            </div>
            <div class="ordergrabbing_mesgbox">
              <img class="ordergrabbing_img" src="/static/nameicon.png" />
              <div class="ordergrabbing_textvalue">姓名：{{item.owner}}</div>
            </div>
            <div class="ordergrabbing_mesgbox" v-if="item.product_name!='预约年检'">
              <img class="ordergrabbing_img" src="/static/jiecheaddress.png" />
              <div class="ordergrabbing_text">接车地点：</div>
              <div class="ordergrabbing_text1">{{item.address}}</div>
            </div>
            <div class="ordergrabbing_mesgbox" v-else>
              <img class="ordergrabbing_img" src="/static/storeName.png" />
              <div class="ordergrabbing_textvalue">检测站名：{{item.store ? item.store.name :""}}</div>
            </div>
            <div class="ordergrabbing_mesgbox" v-if="item.product_name=='预约年检'">
              <img class="ordergrabbing_img" src="/static/bookTime.png" />
              <div class="ordergrabbing_textvalue">预约时间：{{item.store_book_date}} {{item.store_book_time}}</div>
            </div>
            <div class="ordergrabbing_mesgbox" v-else>
              <img class="ordergrabbing_img" src="/static/bookTime.png" />
              <div class="ordergrabbing_textvalue">预约时间：{{item.book_date}} {{item.book_time}}</div>
            </div>
          </div>
          <div class="ordergrabbing_bottom">
            <div class="ordergrabbing_carmesg">
              <img class="ordergrabbing_caricon" src="/static/pinpaicjexing.png" />
              <div class="ordergrabbing_cartext">{{item.car_no}}</div>
            </div>

          </div>
          <div class="ordergrabbing_botton1" @click="toOrderStaus(index)">马上抢</div>
        </div>
        <div @click="getMore()" class='ordergrabbing_label more' v-if="datalengthX">查看更多</div>
      </div>

    </div>
  </div>
</template>

<script>
  import httper from '../../api/http'
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        userInfo: "",
        sentList: [],
        pages: 1,
        page_size: 20,
        datalengthX: false
      }
    },
    created() {
      let that = this
      this.request("getOrderList", {
        page: this.pages,
        page_size: this.page_size
      })
      this.userInfo = JSON.parse(localStorage.getItem('userinfo'))
      console.log("this.userInfo", this.userInfo)
      if (that.userInfo.is_bind == 0) {
        Dialog.alert({
          title: '提示',
          message: '请先进行绑定',
        }).then(() => {
          that.$router.push({
            path: "/grabbingLogin"
          })
        });

      }
    },
    mounted() {

    },
    methods: {
      toOrderStaus(e) {
        let that = this
        this.request("receiveOrder", {
          annual_review_id: that.sentList[e].id
        })
      },
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          //刚进入页面获取的数据
          case 'getOrderList':
            httper.get('/annual-review/sent-list', requestData, function(res) {
              if (res.code === 0) {
                let lengthX = res.data.length - 20 === 0 //判断列是否20条
                that.datalengthX = lengthX
                console.log("res", res)
                if (res.data.length > 0) {
                  let list = that.sentList;
                  for (let i = 0; i < res.data.length; i++) {
                    list.push(res.data[i]);
                  }
                  that.sentList = list
                }
                // that.sentList = res.data
                // console.log("that.sentList", that.sentList)
              } else {
                that.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //抢单
          case 'receiveOrder':
            httper.post('/annual-review/receive-order', requestData, function(res) {
              if (res.code === 0) {
                console.log("res", res)
                that.$router.push({
                  path: "/orderStatus"
                })
              } else {
                that.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
        }
      },
      //查看更多
      getMore() {
        let that = this
        console.log("获取更多")
        if (!that.datalengthX) {
          this.$toast({
            message: '没有更多了'
          })
          return
        }
        let page = (that.pages) + 1
        that.pages = page
        this.request("getAccountLog", {
          page: page,
          page_size: this.page_size
        })
      },
    }
  }
</script>

<style>
  .order_grabbing {
    width: 100%;
    height: 249px;
  }

  .ordergrabbing_banner {
    width: 100%;
    height: 100%;
  }

  .ordergrabbing_list {
    width: 100%;
    background-image: url(../../../static/qiangdan.png);
    background-size: 100% 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-y: auto;
  }

  .ordergrabbing_list1 {
    width: 100%;
    position: absolute;
    top: 37%;
  }

  .ordergrabbing_box {
    width: calc(100% - 40px);
    margin: 0 20px 20px 20px;

    padding: 10px;
    box-sizing: border-box;
    background-color: #FFFFFF;
    border-radius: 8px;
  }

  .ordergrabbing_top {
    width: 100%;
    border-bottom: 1px solid #DCDCDC;
  }

  .ordergrabbing_mesgbox {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
  }

  .ordergrabbing_img {
    width: 14px;
    height: 14px;
    margin-right: 5px;
  }

  .ordergrabbing_textvalue {
    font-size: 14px;
    color: #363636;
  }

  .ordergrabbing_text {
    width: 25%;
    font-size: 14px;
    color: #363636;
  }

  .ordergrabbing_text1 {
    width: 75%;
    font-size: 14px;
    color: #363636;
    display: flex;
    flex-wrap: wrap;

  }

  .ordergrabbing_bottom {
    width: 100%;
    /* padding: 10px 0; */
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .ordergrabbing_carmesg {
    display: flex;
    align-items: center;

  }

  .ordergrabbing_caricon {
    width: 15px;
    height: 17px;
    margin-right: 5px;
  }

  .ordergrabbing_cartext {
    font-size: 14px;
    color: #666666;
  }

  .ordergrabbing_botton {
    width: 58px;
    height: 23px;
    background: #FD8C00;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #FFFFFF;
  }

  .ordergrabbing_botton1 {
    width: 337px;
    height: 46px;
    background: #FD8C00;
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #FFFFFF;
    margin-top: 10px;
  }

  .ordergrabbing_label {
    margin: 20px 15px 0;
    display: block;
    text-align: center;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .more {
    padding: 10px 0;
    text-align: center;
    font-size: 15px;
    border: 1px solid #E3E3E3;
    box-shadow: 0 3px 3px #E3E3E3;
    color: orange;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/orderGrabbing/orderGrabbing.vue